import { Observable } from 'rxjs';
import { ProductsRepository, ApiResponse } from '../domain/products/repository';
import { Product } from '../domain/products/model';

import HttpClient from '../utils/http-client';

export class ProductsRepositoryImplementation extends ProductsRepository {
    getAllProducts(
        uid: string,
        cid: string | null,
        query = "",
        page = 1,
        limit = 20,
        onlyEnabled = false,
        onlyNegativeStock = false,
        hasTax: boolean | null = null,
        stockStatus: string | null = null,
        hasWarranty: boolean | null = null,
        enable: boolean | null = null
    ): Observable<ApiResponse> {
        const httpClient = new HttpClient(uid, cid);
        const params: Record<string, unknown> = { page, limit, only_enabled: onlyEnabled };
        if (query) params.query = query;
        if (onlyNegativeStock) params.only_negative_stock = true;
        if (hasTax !== null) params.has_tax = hasTax;
        if (stockStatus) params.stock_status = stockStatus;
        if (hasWarranty !== null) params.has_warranty = hasWarranty;
        if (enable !== null) params.enable = enable;

        return httpClient.get('/product', params);
    }

    uploadProductInventory(uid: string, cid: string | null, body: unknown): Observable<ApiResponse> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post('/product/upload', body);
    }

    createProduct(uid: string, cid: string | null, data: Partial<Product>): Observable<ApiResponse> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post('/product', data);
    }

    isEnable(uid: string, cid: string | null, id: string | number, is_enable: boolean): Observable<ApiResponse> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.put(`/product/${id}`, { enable: is_enable });
    }

    getProductById(uid: string, cid: string | null, sku: string): Observable<ApiResponse> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get(`/product/${sku}`);
    }

    editProduct(uid: string, cid: string | null, data: Partial<Product>, id: string | number): Observable<ApiResponse> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.put(`/product/${id}`, data);
    }

    checkProductDuplicate(uid: string, cid: string | null, value: string): Observable<ApiResponse> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.get('/product/check-duplicate', { value });
    }

    matchProducts(uid: string, cid: string | null, items: Array<{ sku?: string; description: string }>): Observable<ApiResponse> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.post('/product/match', { items });
     }

    deleteProduct(uid: string, cid: string | null, id: string | number): Observable<ApiResponse> {
        const httpClient = new HttpClient(uid, cid);
        return httpClient.delete(`/product/${id}`);
    }
}
